var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticClass: "v-menu",
      attrs: {
        left: "",
        origin: "center center",
        transition: "scale-transition",
        "data-testid":
          (_vm.params.testId ? _vm.params.testId + "__" : "") + "MenuItem"
      }
    },
    [
      _c(
        "v-btn",
        { attrs: { slot: "activator", icon: "" }, slot: "activator" },
        [_c("v-icon", { attrs: { color: "#526da5" } }, [_vm._v("more_vert")])],
        1
      ),
      _c(
        "v-list",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mostrarMenuAcciones,
              expression: "mostrarMenuAcciones"
            }
          ]
        },
        [
          _vm.btnVerPdf
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.VerPdf)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v(_vm._s(_vm.btnVerIcon))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerPdf)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDejarDeRecibir
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.DejarRecibirInformacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("block")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.DejarRecibirInformacion
                          )
                        }
                      }
                    },
                    [_vm._v("Dejar de recibir")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnAceptar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.AceptarInformacionCompartida
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("done")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.AceptarInformacionCompartida
                          )
                        }
                      }
                    },
                    [_vm._v("Aceptar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnRechazar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.RechazarInformacionCompartida
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("clear")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.RechazarInformacionCompartida
                          )
                        }
                      }
                    },
                    [_vm._v("Rechazar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerDetalle
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.VerDetalle)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("info")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerDetalle)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerDetalleText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditar
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledEditBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledEditBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Editar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Editar)
                        }
                      }
                    },
                    [_vm._v("Editar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnImportar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.accionImportar
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("cloud_upload")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.accionImportar)
                        }
                      }
                    },
                    [_vm._v("Importar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCargarArchivo
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledEditBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledEditBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.cargarArchivo
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.cargarArchivo)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnCargarArchivoTexto))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnRevertirEjecucion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.accionRevertirEjecucion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("settings_backup_restore")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.accionRevertirEjecucion
                          )
                        }
                      }
                    },
                    [_vm._v("Revertir Ejecución")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminar
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Eliminar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Eliminar)
                        }
                      }
                    },
                    [_vm._v("Eliminar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditarApn
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.EditarApn)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EditarApn)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.texto_editar))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerHistorico
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.VerHistorico
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("manage_search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerHistorico)
                        }
                      }
                    },
                    [_vm._v("Ver Historial De Estados")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminarApn
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.EliminarApn)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EliminarApn)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.texto_eliminar))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditarPlan
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.EditarPlan)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EditarPlan)
                        }
                      }
                    },
                    [_vm._v("Editar Plan")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminarPlan
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EliminarPlan
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EliminarPlan)
                        }
                      }
                    },
                    [_vm._v("Eliminar Plan")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditarApnCrear
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EditarApnCrear
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EditarApnCrear)
                        }
                      }
                    },
                    [_vm._v("Editar Apn")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminarApnCrear
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EliminarApnCrear
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.EliminarApnCrear
                          )
                        }
                      }
                    },
                    [_vm._v("Eliminar Apn")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditarStockCrear
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EditarStockCrear
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.EditarStockCrear
                          )
                        }
                      }
                    },
                    [_vm._v("Editar Stock")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminarStockCrear
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EliminarStockCrear
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.EliminarStockCrear
                          )
                        }
                      }
                    },
                    [_vm._v("Eliminar Stock")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditarStock
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.EditarStock)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EditarStock)
                        }
                      }
                    },
                    [_vm._v("Editar Stock")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEliminarStock
            ? _c(
                "v-list-tile",
                {
                  staticStyle: { height: "40px" },
                  attrs: { disabled: !_vm.enabledDeleteBtn }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            disabled: !_vm.enabledDeleteBtn
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EliminarStock
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.EliminarStock)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.texto_eliminar_p))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDejarDeCompartir
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.NoRecibirInformacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("block")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.NoRecibirInformacion
                          )
                        }
                      }
                    },
                    [_vm._v("Dejar de compartir")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCancelar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Cancelar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("block")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Cancelar)
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDesbloquear
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Desbloquear)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("lock")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Desbloquear)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnDesbloquearText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerReferencia
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.VerReferencia
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v(_vm._s(_vm.btnVerReferenciaIcon))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerReferencia)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnVerReferenciaText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnExportarCRM
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.Exportar_A_CRM
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("ios_share")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Exportar_A_CRM)
                        }
                      }
                    },
                    [_vm._v("Exportar a CRM")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDescargar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Descargar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("cloud_download")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Descargar)
                        }
                      }
                    },
                    [_vm._v("Descargar " + _vm._s(_vm.btnDescargarText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCambiarContraseña
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: { click: _vm.changePassword }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("key")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: { click: _vm.changePassword }
                    },
                    [_vm._v("Cambiar Contraseña")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEnviar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Enviar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Enviar)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.btnEnviarText))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCompartir
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.compartir)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("share")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.compartir)
                        }
                      }
                    },
                    [_vm._v(_vm._s(this.btnCompartirTexto))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnAsociarGps
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.AsociarGps)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("add")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.AsociarGps)
                        }
                      }
                    },
                    [_vm._v("Asociar Gps")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnAnular
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Anular)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("lock")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Anular)
                        }
                      }
                    },
                    [_vm._v("Anular")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnFacturar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Facturar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("task")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Facturar)
                        }
                      }
                    },
                    [_vm._v("Informar Facturada")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnSolicitarAutorizacion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.SolicitarAutorizacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("check")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.SolicitarAutorizacion
                          )
                        }
                      }
                    },
                    [_vm._v("Solicitar Autorización")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnEditarAutorizadores
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.EditarAutorizadores
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.EditarAutorizadores
                          )
                        }
                      }
                    },
                    [_vm._v("Editar Autorizadores")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnIncluirCostosImportacion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.IncluirCostosImportacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.IncluirCostosImportacion
                          )
                        }
                      }
                    },
                    [_vm._v("Ver Costos De Importación")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerAutorizacion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.VerAutorizacion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("info")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerAutorizacion)
                        }
                      }
                    },
                    [_vm._v("Ver Autorización")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnGenerarAtencion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.GenerarAtencion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("receipt_long")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.GenerarAtencion)
                        }
                      }
                    },
                    [_vm._v("Generar Atención")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnFacturacionEspecial
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.FacturacionEspecial
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("receipt_long")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.FacturacionEspecial
                          )
                        }
                      }
                    },
                    [_vm._v("Informar Factura Especial")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnAccionReutilizable
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.AccionReutilizable
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v(_vm._s(_vm.iconoAccionReutilizable))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.AccionReutilizable
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.textoAccionReutilizable) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnInformarRecepcion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.InformarRecepcion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("task")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.InformarRecepcion
                          )
                        }
                      }
                    },
                    [_vm._v("Informar Recepción")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnVerEstadoSeries
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.VerEstadoSeries
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.VerEstadoSeries)
                        }
                      }
                    },
                    [_vm._v("Ver Estado Series")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnGenerarRecepcion
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.GenerarRecepcion
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("settings")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.GenerarRecepcion
                          )
                        }
                      }
                    },
                    [_vm._v("\n        Generar Recepción\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnAgregarEquipos
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.AgregarEquipos
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("add_circle")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.AgregarEquipos)
                        }
                      }
                    },
                    [_vm._v("\n        Agregar Equipo\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnGestionarDespacho
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.GestionarDespacho
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("local_shipping")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.GestionarDespacho
                          )
                        }
                      }
                    },
                    [_vm._v("\n        Gestionar Despacho\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnverevidencias_fila
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.ver_evidencias
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("camera")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.ver_evidencias)
                        }
                      }
                    },
                    [_vm._v("Ver Evidencias")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnGenerarMovimiento
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.GenerarMovimiento
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("schedule_send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.GenerarMovimiento
                          )
                        }
                      }
                    },
                    [_vm._v("\n        Generar Movimiento\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnGenerarEncomienda
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.GenerarEncomienda
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("schedule_send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.GenerarEncomienda
                          )
                        }
                      }
                    },
                    [_vm._v("\n        Generar Encomienda\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnCompletar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.Finalizar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("check_circle")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.Finalizar)
                        }
                      }
                    },
                    [_vm._v("Finalizar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnverevidencias_fila
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.ver_evidencias
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("camera")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.ver_evidencias)
                        }
                      }
                    },
                    [_vm._v("Ver Evidencias")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnExportar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(_vm.Accion.exportar)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("ios_share")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.exportar)
                        }
                      }
                    },
                    [_vm._v("Exportar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnGerarEnvio
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.accionGenerarEnvio
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.accionGenerarEnvio
                          )
                        }
                      }
                    },
                    [_vm._v("Generar Envío")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnDevolverAFinanzas
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.DevolverAFinanzas
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("send")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.DevolverAFinanzas
                          )
                        }
                      }
                    },
                    [_vm._v("Generar Envío")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnActualizarEstado
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.ActualizarEstado
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("update")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(
                            _vm.Accion.ActualizarEstado
                          )
                        }
                      }
                    },
                    [_vm._v("Actualizar Estado")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.btnActualizarNDV
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleItemClick(
                                _vm.Accion.ActualizarNDV
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526DA5" } },
                            [_vm._v("update")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0, 0, 0, 0.7)"
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleItemClick(_vm.Accion.ActualizarNDV)
                        }
                      }
                    },
                    [_vm._v("Actualizar Nota de Ventas")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }